<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <h4 class="about-title">{{ ls_AboutUs }}</h4>
        <b-card class="about-card">
          <div class="about-content" v-html="aboutUs"></div>
        </b-card>
      </b-col>
      <b-col cols="4">
        <div class="sidebar-banner">
          <b-link :href="host + '/ads/show/14.html'" target="_blank" class="sidebar-banner-link">
            <img :src="host + '/ads/show/14.png'" alt="Ads">
          </b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";

export default {
  data() {
    return {
      aboutUs: ""
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    menuList() {
      let list = [];
      if (this.$store.state.navigationList.length > 0) {
        list = this.$store.state.navigationList.filter(
          n => n.url === "/about/us"
        )[0].childList;
      }

      return list;
    },

    currentMenu() {
      return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    ls_AboutUs() {
      return this.$store.state.languagePack.ls_AboutUs;
    },

    leaderMenuList() {
      let leaderMenus = [];
      if (this.menuList.length > 0) {
        this.menuList.forEach(function(menu) {
          leaderMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
      }
      return leaderMenus;
    }
  },

  created() {
    this.getAboutUs();
  },

  methods: {
    getAboutUs() {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getaboutus", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.aboutUs = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getAboutUs();
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_AboutUs
    };
  },

  components: {
    "sidebar-nav": SidebarNavigation
  }
};
</script>

<style lang="scss">
.about-card {
  border-radius: 0 !important;
  border: 1px solid #dddfe2;

  .about-content,
  .about-content * {
    font-size: 17px;
    color: #333333;
    line-height: 1.5;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    text-align: left !important;
  }
  .about-content p {
    margin-bottom: 20px !important;
  }
}

/* RTL */

.rtl-layout {

  .about-title {
    direction: rtl;
    text-align: right;
  }

  .about-content,
  .about-content *,
  .about-content p,
  .about-content p strong {
    direction: rtl !important;
    text-align: right !important;
  }
}
</style>

<style>
.sidebar-banner {
  margin-top: 48px;
  background-color: #ffffff;
}
.sidebar-banner .sidebar-banner-link img {
  width: 100%;
}
.about-title {
  font-size: 30px;
  color: #008496;
  padding-bottom: 4px;
}
.about-content p {
  margin-bottom: 4px;
  font-size: 18px;
  font-weight: 500;
  text-indent: 16px;
  color: #585858;
}
.about-content p > strong {
  display: inline-block;
  color: #333333;
  font-size: 20px;
  padding: 0;
  margin-left: -16px;
  text-indent: 0px;
  text-align: start !important;
  margin-bottom: 8px !important;
}
.about-content ul > li {
  font-size: 18px;
  color: #585858;
}
</style>
